import React from "react";
import PrintProjectsGrid from "../../../common_components/PrintProjectsGrid";
import CmykVertLarge from "../../../common_components/design_components/CmykVertLarge";
import Mark from "../../../common_components/design_components/Mark";
import "../../../styles/PrintProjects.scss";

const PrintProjectsDesktop = () => {
  return (
    <div className="print-projects">
      {/* Registration Marks */}
      <div className="registration-mark top-left">
        <Mark />
      </div>
      {/* Sidebar/Text Section */}
      <aside className="text-section">
        <div className="title-container">
          <h1 className="title">PRINT PROJECTS</h1>
          <CmykVertLarge />
        </div>
        <div className="text-container-desktop">
          <p>
            A variety of printed materials designed for campaigns, events, and branding purposes. This collection includes brochures, newsletters, posters, business cards, and more, created to meet the needs of different audiences and objectives.
          </p>
        </div>
      </aside>
      {/* Grid Section */}
      <section className="grid-section">
        <PrintProjectsGrid />
      </section>
    </div>
  );
};

export default PrintProjectsDesktop;